export default __webpack_public_path__ + "static/media/debate_22.a1ce1211.JPG";